module.exports = __webpack_public_path__ + "media/images/iconSocialLink--dark-50b65b9dbcd5a6143d013fbf27876cdb.png";